import { IObjective } from '../interfaces/training-event.objective.interface';

export class Objective {
  public name: string;

  constructor(data?: IObjective) {
    Object.assign(this, data);
  }
}
